module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"inStore":"In Store"},"de":{"inStore":"Auf Lager"}}')
  delete Component.options._Ctor
}
